import React from 'react';
import { Col } from 'react-bootstrap';
import SocialMedia from './SocialMedia';
import styles from './Footer.module.scss';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  const actualYear = new Date().getFullYear();

  return (
    <footer className="d-flex flex-wrap justify-content-between align-items-center py-3 border-top">
          <Col xs={8} className={["d-flex", "align-items-center", styles['footer-div']].join(' ')}>
            <Link to="/" className="me-2 text-decoration-none lh-1">
              <img src="/assets/logo.svg" className={styles["logo-footer"]} alt="Logo" />
            </Link>
            <span className="text-body-secondary">
              © {actualYear} Mayara Sena
            </span>
          </Col>
          <Col xs={4} className={[styles['footer-div'], "d-flex", "justify-content-end"].join(' ')}>
            <SocialMedia />
          </Col>
    </footer>
  );
};

export default Footer;
